import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog-left-sidebar',
  templateUrl: './breadcrumb-blog-left-sidebar.component.html',
  styleUrls: ['./breadcrumb-blog-left-sidebar.component.css']
})
export class BreadcrumbBlogLeftSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
